export default "__VITE_ASSET__DvpTliPL__"